// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".space-header[data-v-1aa77544]{box-sizing:border-box;margin-bottom:10px}@media(max-width:960px){.space-header[data-v-1aa77544]{margin-bottom:0}}", ""]);
// Exports
module.exports = exports;
